import {Controller} from "@hotwired/stimulus"

class DelaySubmitController extends Controller {
  static values = {delay: Number}

  connect() {
    this.alreadySubmitted = false
    this.isFinished = false
  }

  submit(event) {
    if (this.isFinished) return

    event.preventDefault()
    if (this.alreadySubmitted) return

    this.alreadySubmitted = true
    this.dispatch("delaying_started")

    setTimeout(() => {
      this.isFinished = true
      this.dispatch("delaying_finished")
      // this will trigger this submit method again
      this.element.requestSubmit()
    }, this.delayValue || 500)
  }
}

export default DelaySubmitController
